// Flag to track whether the alert has been shown
var alertShown = false;

// Function to handle the click event for adding products to the selection
var CheckoutClickAjax = function () {
  function CallGetCodeAjax(event) {
    var button = event.target;
    // Check if the clicked element is the button itself
    if ($(button).is('.addToSelectionButton')) {
      var title = button.getAttribute('data-product-title');
      var image = button.getAttribute('data-product-image');
      var variantId = button.getAttribute('data-variant-id');
      var price = button.getAttribute('data-variant-price').replace(/<[^>]*>/g, '') // Remove HTML tags
                                                         .trim() // Trim whitespace
                                                         .replace(/^(Rs\.|₹)\s*/, ''); // Remove "Rs." or "₹" and any following whitespace

      var quantity = parseInt(document.getElementById(`quantity${variantId}`).value, 10) || 0;

      if (quantity > 0) {
        addToSelection(title, image, variantId, price, quantity, button);
      }
    }
  }
  $('.add-to-cart.sf__btn').once('click', CallGetCodeAjax);
}

// Extend jQuery with a once function to handle single event binding
$.fn.once = function(a, b) {
  return this.each(function() {
    $(this).off(a).on(a, b);
  });
};

// Function to add a product to the selection
 // Function to add a product to the selection
        function addToSelection(title, image, variantId, price, quantity, button) {
          var existingItems = JSON.parse(localStorage.getItem('selectedProducts')) || [];
          var newItem = {
            title: title,
            image: image,
            variantId: variantId,
            price: price
          };

          var existingQuantity = existingItems.filter(function(item) {
            return item.title === title && item.variantId === variantId;
          }).length;

          var totalQuantity = existingQuantity + quantity;

          if (totalQuantity <= 2) {
            var totalNewItems = existingItems.length + quantity;
            if (totalNewItems <= 10) {
              for (let i = 0; i < quantity; i++) {
                existingItems.push(newItem);
              }
              localStorage.setItem('selectedProducts', JSON.stringify(existingItems));

              // Calculate the total price of all selected products
              var totalPrice = existingItems.reduce((sum, item) => sum + parseFloat(item.price), 0);
              localStorage.setItem('totalPrice', totalPrice);

              // Calculate the discounted price (assuming a discount of 10%)
              var discountRate = 0.10;
              var discountedPrice = totalPrice * (1 - discountRate);
              localStorage.setItem('discountedPrice', discountedPrice);

              button.textContent = 'Selected'; // Change button text to indicate selection
              setTimeout(updateAllProducts);
            } else {
              showAlert('You can only select up to 10 products.');
            }
          } else {
           button.textContent = 'Selected';
            showAlert('You can only select up to 2 of each product.');
          }
        }

        // Function to display the prices on the cart page
        function displayPrices() {
          var totalPrice = localStorage.getItem('totalPrice');
          var discountedPrice = localStorage.getItem('discountedPrice');

          if (totalPrice) {
            document.getElementById('total-price-amount').textContent = totalPrice;
          } else {
            document.getElementById('total-price-amount').textContent = "0"; // Display 0 if no price found
          }

          if (discountedPrice) {
            document.getElementById('discounted-price-amount').textContent = discountedPrice;
          } else {
            document.getElementById('discounted-price-amount').textContent = "0"; // Display 0 if no price found
          }
        }

        // Call the function to display the prices when the cart page loads
        window.onload = displayPrices;


// Function to show alert with a delay for resetting
function showAlert(message) {
  if (!alertShown) {
    alert(message);
    alertShown = true; // Set flag to true after showing alert
    setTimeout(function() {
      alertShown = false;
    }, 2000); // Reset after 2 seconds
  }
}

// Function to update all displayed products
function updateAllProducts() {
  removehtmlProduct(); // Clear previous product data
  var storedProducts = JSON.parse(localStorage.getItem('selectedProducts')) || [];
  storedProducts.forEach(function(product, index) {
    var productContainer = document.querySelector(`.dyn-product-${index + 1}.single-wish-product`);
    if (productContainer) {
      var productImage = productContainer.querySelector(`.prod-${index + 1}-img.wish-pd img`);
      productImage.src = product.image;
      productImage.srcset = product.image;
      productImage.alt = product.title;

      var productPrice = productContainer.querySelector(`.pric-del .wish-price.prod-${index + 1}-price`);
      productPrice.textContent = 'Rs ' + (product.price || 0);

      var productTitle = productContainer.querySelector(`.wish-dyn-content.temp-padding h4`);
      productTitle.textContent = product.title;
    }
  });
  if (storedProducts.length >= 2) {
    jQuery('.dyn-add-to-cart-button').show();
  } else {
    jQuery('.dyn-add-to-cart-button').hide();
  }
  var addToSelectionButtons = document.querySelectorAll('.addToSelectionButton');
  addToSelectionButtons.forEach(function(button) {
    var storedProductTitles = storedProducts.map(function(product) {
      return product.title;
    });
    if (storedProductTitles.includes(button.getAttribute('data-product-title'))) {
      button.textContent = 'Selected'; // Change button text to indicate selection
    }
  });
}

// Function to remove all displayed products
function removehtmlProduct() {
  for (var i = 1; i <= 10; i++) {
    var productContainer = document.querySelector(`.dyn-product-${i}.single-wish-product`);
    if (productContainer) {
      var productImage = productContainer.querySelector(`.prod-${i}-img.wish-pd img`);
      productImage.src = '//cdn.shopify.com/s/files/1/0089/0893/1152/files/collection-lazy-banner-mobile.jpg?v=17573325351953088787';
      productImage.srcset = '//cdn.shopify.com/s/files/1/0089/0893/1152/files/collection-lazy-banner-mobile.jpg?v=17573325351953088787';
      productImage.alt = 'no image';

      var productPrice = productContainer.querySelector(`.pric-del .wish-price.prod-${i}-price`);
      productPrice.textContent = 'Rs';

      var productTitle = productContainer.querySelector('.wish-dyn-content.temp-padding h4');
      if (i == 1) {
        productTitle.innerHTML = `Select your 1<sup>st</sup> product`;
      } else if (i == 2) {
        productTitle.innerHTML = `Select your 2<sup>nd</sup> product`;
      } else if (i == 3) {
        productTitle.innerHTML = `Select your 3<sup>rd</sup> product`;
      } else if (i == 4) {
        productTitle.innerHTML = `Select your 4<sup>th</sup> product`;
      }
    }
  }
}

// Function to remove a product from the selection
function removeProduct(index) {
  var storedProducts = JSON.parse(localStorage.getItem('selectedProducts')) || [];
  storedProducts.splice(index - 1, 1);
  setTimeout(function() {
    localStorage.setItem('selectedProducts', JSON.stringify(storedProducts));
    updateAllProducts();
    var addToSelectionButtons = document.querySelectorAll('.addToSelectionButton');
    addToSelectionButtons.forEach(function(button, idx) {
      if (idx === index - 1) {
        button.textContent = 'Select'; // Change button text to initial state
      }
    });
  }, 1000); // Delay in milliseconds
}

// Function to add selected products to the shopping bag
function addToBag() {
  var selectedProducts = JSON.parse(localStorage.getItem('selectedProducts'));
  if (selectedProducts) {
    var productTitles = {};
    selectedProducts.forEach(function(product, index) {
      productTitles['Product ' + (index + 1)] = product.title;
    });
    var addToBagButton = document.querySelector('.addtocart');
    var vidPasstoCart = 0;
    if (addToBagButton) {
      var vid = addToBagButton.getAttribute('vid');
      vidPasstoCart = vid;
    }

    var productObj = {
      "id": vidPasstoCart,
      "quantity": 1, 
      "properties": productTitles
    };

    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: productObj,
      dataType: 'json',
      success: function() {
        setTimeout(function() {
          removehtmlProduct();
          localStorage.removeItem('selectedProducts');
          window.location.href = '/cart'; // Redirect to cart page
        }, 500);
      }
    });
  }
}

// Initial update of displayed products
setTimeout(updateAllProducts, 500);
CheckoutClickAjax();
(function() {
  localStorage.removeItem('selectedProducts');
})();






